// Tunable knobs for the Sentiment widget — thresholds + the polarity buckets.
// The polarity MAPS (category→polarity, emotion→polarity) are shared with the
// Feature widget, so they live in ../sentiment and are re-exported here. The
// card's status/trend gates mirror v1's cardExecutor.computeCardSignal + formatChange.

import { POSITIVE, NEGATIVE, NEUTRAL, CATEGORY_POLARITY, EMOTION_POLARITY, SENTIMENT_SOURCE } from "../sentiment";

export { POSITIVE, NEGATIVE, NEUTRAL };

export const CONFIG = {
  // Polarity source — shared dashboard-wide (see ../sentiment SENTIMENT_SOURCE);
  // flip it there to switch both this widget and the Feature widget together.
  source: SENTIMENT_SOURCE,

  // |Δ positive-share points| ≤ this → "Stable" / "No change" (v1: ±5).
  changeGatePct: 5,
  // Positive share strictly above this reads green / good (v1: >50%).
  goodThresholdPct: 50,

  // Shared polarity maps (see ../sentiment).
  categoryPolarity: CATEGORY_POLARITY,
  emotionPolarity: EMOTION_POLARITY,

  // The fixed polarity buckets, in render order.
  polarityBuckets: [
    { display: "Positive", value: POSITIVE },
    { display: "Negative", value: NEGATIVE },
    { display: "Neutral", value: NEUTRAL },
  ],
};
